import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

export const getRefundListViaStatusApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {

        formDataCommonFunction(data, apiConstants.PAYMENT_GATEWAY.GET_REFUND_LIST_VIA_STATUS)
            .then((response) => {
                callback && callback(response)

            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
